/* COMPONENTS */
import './components/form';
import './components/formFile';
import './components/select';
import './components/formSteps';

/* PARTIALS */
// import './partials/header';
import './partials/loginWidgetInit';
import './partials/footer';
import './partials/modal';
import './partials/widgetScroll';

/* MODULES */
import '../../modules/team/team';
import '../../modules/hero/hero';
import '../../modules/accordion/accordion';
import '../../modules/table/table';
import '../../modules/feedback/feedback';
import '../../modules/booking/booking';
import '../../modules/booking-association/booking-association';
import '../../modules/booking-appointment/booking-appointment';
import '../../modules/prescription/prescription';
import '../../modules/prescription-result/prescription-result';
import '../../modules/login/login';
import '../../modules/membership-subscription/membership-subscription';
import '../../modules/membership-details/membership-details';
import '../../modules/quotation/quotation';
import '../../modules/registration/registration';
import '../../modules/profile/profile';
import '../../modules/voucher-activation/voucher-activation';
import '../../modules/corporate-profile/corporate-profile';
import '../../modules/corporate-login/corporate-login';
import '../../modules/doctify-carousel/doctify-carousel';
import '../../modules/location-finder/location-finder';
import '../../modules/vaccine-booking/vaccine-booking';
import '../../modules/late-payment/late-payment';
import '../../modules/contact-form/contact-form';
import '../../modules/generic-payment/generic-payment';
import '../../modules/doctify-carousel/doctify-carousel';
